






























// import data from '@/assets/data.json'
import {Component, Ref, Vue} from 'vue-property-decorator';
import myNav from '@/components/Nav.vue';
import Data from '@/views/pages/data.ts';

@Component({
  components: {
    myNav
  },
})
export default class production extends Vue {
  @Ref('container') container!: any;
  @Ref('bannerImg') bannerImg!: any;

  data = new Data();
  bannerUrl = require('@/assets/production/banner1.png');
  banerHeight = 0;
  // 导航标题列表
  navList = ['工单管理', '设备管理', '备件管理', '客户管理', '统计分析'];

  // 内容列表
  contentList = this.data.productionList;
  // 供展示的内容
  content = this.contentList[0];

  // 导航（子组件）点击监听
  indexChange(e: number | null){
    if(e!==null) {
      this.content = this.contentList[e];
      this.bannerUrl = require(`@/assets/production/banner${e+1}.png`);
      // const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // // 滚动超过导航条
      // if(scrollTop >= this.container.offsetTop){
      //   document.body.scrollTop = document.documentElement.scrollTop = this.container.offsetTop - 90 - 75;
      // }
    }
  }
  mounted(){
    this.banerHeight = document.body.clientWidth * 612/1920;
  }
}
